import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import React, { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { TextFieldInputNumber, parseFloatCheckValue, parseFloatNotZero } from '../Ticket/fnTickit';
import _ from "lodash";
import { debounce } from 'lodash';
import { ProviderExpenseActual, arrMock } from './FundExpenseActualForm';
import { FnDialog } from 'utilities/utilities';
import InputReactNumber from '../InputReactNumber';

const TableActualExpenseSectionProject = (props: { item: any; keyId: any; }) => {

    const {
        arrMonth,
        setLstExpense,
        lstProject,
        setLstProject,
        calIndexOld,
        form,
        isView
    } = useContext(ProviderExpenseActual);

    const { item, keyId } = props;
    const DialogFn = FnDialog();

    const lstProjectSection = useMemo(() => {
        let lstData = [];
        if (lstProject != null && lstProject.length > 0) {
            lstData = lstProject.filter((f: { nSectionId: any; }) => f.nSectionId === item.nSectionId);
        }
        return lstData
    }, [item.nSectionId, lstProject])

    const [ObjTotal, setObjTotal] = useState({
        nId: 9999,
        nProjectID: 0,
        sProjectName: "รวมค่าใช้จ่าย",
        nSectionId: 0,
        nOrder: 0,
        nTotal: null,
        nQ1: null,
        nQ2: null,
        nQ3: null,
        nQ4: null,
        nTotalActual: null,
        nQ1Actual: null,
        nQ2Actual: null,
        nQ3Actual: null,
        nQ4Actual: null,
        nTotalDiff: null,
        nPercentage: null,
        lstExpenseMonth: _.cloneDeep(arrMock),
        lstActualMonth: _.cloneDeep(arrMock),
        isTotal: true
    })

    const handleChangeTotal = useCallback((indexMonth, keyRow, itemTable, keyInput) => {

        let objTotal = {
            nId: 9999,
            nProjectID: 0,
            sProjectName: "รวมค่าใช้จ่าย",
            nSectionId: 0,
            nOrder: 0,
            nTotal: null,
            nQ1: null,
            nQ2: null,
            nQ3: null,
            nQ4: null,
            nTotalActual: null,
            nQ1Actual: null,
            nQ2Actual: null,
            nQ3Actual: null,
            nQ4Actual: null,
            nTotalDiff: null,
            nPercentage: null,
            lstExpenseMonth: _.cloneDeep(arrMock),
            lstActualMonth: _.cloneDeep(arrMock),
            isTotal: true
        }
        if (lstProject != null && lstProject.length > 0) {
            let lstData = lstProject.filter((f: { nSectionId: any; }) => f.nSectionId === item.nSectionId);
            let lstInputMonthTotalPlan = _.cloneDeep(arrMock);
            lstInputMonthTotalPlan.forEach((eleInput: { nOrder: number; value: any; }) => {
                let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, sPathValue, 0)));
            });
            let lstInputMonthTotalActual = _.cloneDeep(arrMock);
            lstInputMonthTotalActual.forEach((eleInput: { nOrder: number; value: any; }) => {
                let sPathValue = `lstActualMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, sPathValue, 0)));
            });

            objTotal.nTotal = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nTotal', 0)));
            objTotal.nQ1 = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ1', 0)));
            objTotal.nQ2 = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ2', 0)));
            objTotal.nQ3 = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ3', 0)));
            objTotal.nQ4 = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ4', 0)));
            objTotal.nTotalActual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nTotalActual', 0)));
            objTotal.nQ1Actual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ1Actual', 0)));
            objTotal.nQ2Actual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ2Actual', 0)));
            objTotal.nQ3Actual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ3Actual', 0)));
            objTotal.nQ4Actual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ4Actual', 0)));
            objTotal.lstExpenseMonth = lstInputMonthTotalPlan;
            objTotal.lstActualMonth = lstInputMonthTotalActual;
            objTotal.nTotalDiff = objTotal.nTotal - objTotal.nTotalActual;
            objTotal.nPercentage = +objTotal.nTotal !== 0 ? (objTotal.nTotalActual / +objTotal.nTotal) * 100 : 0;


            if (objTotal.nTotalDiff < 0) {
                form.setValue(keyInput, "0")
                handleChangeValue("0", indexMonth, keyRow, itemTable, keyInput)
                DialogFn.Warning("ผลรวมเกินแผนที่ตั้งไว้");

                return false;
            }
        }

        setObjTotal(objTotal)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DialogFn, form, item.nSectionId, lstProject])


    const handleChangeValue = (eValue: any, indexMonth: any, keyRow: any, itemTable: any, keyInput) => {
        handleChangeInDebounced.cancel();
        handleChangeInDebounced(eValue, indexMonth, keyRow, itemTable, keyInput);
    }

    const handleChangeInDebounced = debounce((eValue: any, indexMonth: number, keyRow, itemTable, keyInput) => {
        keyRow.value = parseFloatCheckValue(eValue);

        let sumQ1 = parseFloatCheckValue(itemTable.nQ1Actual) ?? 0;
        let sumQ2 = parseFloatCheckValue(itemTable.nQ2Actual) ?? 0;
        let sumQ3 = parseFloatCheckValue(itemTable.nQ3Actual) ?? 0;
        let sumQ4 = parseFloatCheckValue(itemTable.nQ4Actual) ?? 0;
        if ([0, 1, 2].includes(indexMonth)) {
            // Q1
            sumQ1 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value: any; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ1Actual = sumQ1;
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            // Q2
            sumQ2 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value: any; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ2Actual = sumQ2;
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            // Q3
            sumQ3 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value: any; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ3Actual = sumQ3;
        }
        else {
            // Q4
            sumQ4 = _.sumBy(itemTable.lstActualMonth, function (o: { nOrder: number; value: any; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ4Actual = sumQ4;
        }

        itemTable.nTotalActual = sumQ1 + sumQ2 + sumQ3 + sumQ4;
        handleChangeTotal(indexMonth, keyRow, itemTable, keyInput)

        setLstProject((value: any) => [...value])
        setLstExpense((value: any) => [...value])
    }, 500);

    useEffect(() => {
        let objTotal = {
            nId: 9999,
            nProjectID: 0,
            sProjectName: "รวมค่าใช้จ่าย",
            nSectionId: 0,
            nOrder: 0,
            nTotal: null,
            nQ1: null,
            nQ2: null,
            nQ3: null,
            nQ4: null,
            nTotalActual: null,
            nQ1Actual: null,
            nQ2Actual: null,
            nQ3Actual: null,
            nQ4Actual: null,
            nTotalDiff: null,
            nPercentage: null,
            lstExpenseMonth: _.cloneDeep(arrMock),
            lstActualMonth: _.cloneDeep(arrMock),
            isTotal: true
        }
        if (lstProject != null && lstProject.length > 0) {
            let lstData = lstProject.filter((f: { nSectionId: any; }) => f.nSectionId === item.nSectionId);
            let lstInputMonthTotalPlan = _.cloneDeep(arrMock);
            lstInputMonthTotalPlan.forEach((eleInput: { nOrder: number; value: any; }) => {
                let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, sPathValue, 0)));
            });
            let lstInputMonthTotalActual = _.cloneDeep(arrMock);
            lstInputMonthTotalActual.forEach((eleInput: { nOrder: number; value: any; }) => {
                let sPathValue = `lstActualMonth[${eleInput.nOrder - 1}].value`;
                eleInput.value = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, sPathValue, 0)));
            });

            objTotal.nTotal = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nTotal', 0)));
            objTotal.nQ1 = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ1', 0)));
            objTotal.nQ2 = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ2', 0)));
            objTotal.nQ3 = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ3', 0)));
            objTotal.nQ4 = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ4', 0)));
            objTotal.nTotalActual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nTotalActual', 0)));
            objTotal.nQ1Actual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ1Actual', 0)));
            objTotal.nQ2Actual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ2Actual', 0)));
            objTotal.nQ3Actual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ3Actual', 0)));
            objTotal.nQ4Actual = parseFloatNotZero(_.sumBy(lstData, (item: any) => _.get(item, 'nQ4Actual', 0)));
            objTotal.lstExpenseMonth = lstInputMonthTotalPlan;
            objTotal.lstActualMonth = lstInputMonthTotalActual;
            objTotal.nTotalDiff = objTotal.nTotal - objTotal.nTotalActual;
            objTotal.nPercentage = +objTotal.nTotal !== 0 ? (objTotal.nTotalActual / objTotal.nTotal) * 100 : 0;
        }

        setObjTotal(objTotal)
    }, [item.nSectionId, lstProject])


    return (
        <TableContainer id='table-pinned' sx={{ maxHeight: "70vh" }} component={Paper}>
            <Table stickyHeader sx={{ minWidth: 1400 }} >
                <TableHead>
                    <TableRow>
                        <TableCell className="sticky-cell pad-0 head-color head-z400" component="th" padding='none' style={{ minWidth: '440px', width: '440px' }}>
                            <TableCell className='cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                            <TableCell className='cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '300px', width: '300px' }}>รายการ</TableCell>
                            <TableCell className='cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '80px', width: '80px' }}></TableCell>
                        </TableCell>
                        {
                            arrMonth.map((month: string, indexM: number) => {
                                return (
                                    <TableCell
                                        key={month}
                                        component="th"
                                        padding='none'
                                        sx={{
                                            minWidth: '150px',
                                            width: '150px',
                                            backgroundColor: [3, 7, 11, 15].includes(indexM) ? '#70b603 !important' : ""
                                        }}
                                    >
                                        {month}
                                    </TableCell>
                                )
                            })
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        lstProjectSection != null && lstProjectSection.length > 0 ?
                            <>
                                {
                                    lstProjectSection.map((itemTable, indexShow) => {
                                        let keyCellTable = keyId + item.nSectionId + "_" + itemTable.nProjectID;
                                        return (
                                            <Fragment key={keyCellTable}>
                                                <TableRow sx={{ backgroundColor: '#f2f2f2' }}>
                                                    <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{itemTable.isTotal ? "" : indexShow + 1}</TableCell>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>{itemTable.sProjectName}</TableCell>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '80px', width: '80px' }}>แผน</TableCell>
                                                    </TableCell>
                                                    {
                                                        itemTable.lstExpenseMonth.map((keyRow, indexMonth: number) => {
                                                            let keyCellInput = "plan" + keyCellTable + "_" + keyRow.nOrder;
                                                            return (
                                                                <>
                                                                    <TableCell
                                                                        key={keyCellInput}
                                                                        padding='none'

                                                                    >
                                                                        <TextFieldInputNumber value={keyRow.value} digit={2} />
                                                                    </TableCell>
                                                                    {
                                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                                            <TableCell
                                                                                key={keyCellInput}
                                                                                padding='none'

                                                                            >
                                                                                <TextFieldInputNumber value={itemTable["nQ" + calIndexOld(indexMonth)]} />
                                                                            </TableCell>
                                                                            :
                                                                            null
                                                                    }
                                                                    {
                                                                        [11].includes(indexMonth) ?
                                                                            <TableCell
                                                                                padding='none'

                                                                            >
                                                                                <TextFieldInputNumber value={itemTable.nTotal} />
                                                                            </TableCell>
                                                                            :
                                                                            null
                                                                    }
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#ffffff' }} style={{ minWidth: '440px', width: '440px' }}>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '80px', width: '80px' }}>ผล</TableCell>
                                                    </TableCell>
                                                    {
                                                        itemTable.lstActualMonth.map((keyRow, indexMonth: number) => {
                                                            let keyCellInput = (itemTable.isTotal ? "t_" : "") + "Actual" + keyCellTable + "_" + keyRow.nOrder;
                                                            return (
                                                                <>
                                                                    <TableCell
                                                                        key={keyCellInput}
                                                                        padding='none'
                                                                    >
                                                                        <InputReactNumber
                                                                            id={keyCellInput}
                                                                            name={keyCellInput}
                                                                            defaultValue={keyRow.value}
                                                                            required={false}
                                                                            disabled={isView || keyRow.isDisable === true}
                                                                            IsCanMinus={false}
                                                                            IsShowMessageError={false}
                                                                            maxInteger={20}
                                                                            onChange={(eValue) => handleChangeValue(eValue, indexMonth, keyRow, itemTable, keyCellInput)}
                                                                        />
                                                                    </TableCell>
                                                                    {
                                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                                            <TableCell
                                                                                key={keyCellInput}
                                                                                padding='none'
                                                                            >
                                                                                <TextFieldInputNumber value={itemTable["nQ" + calIndexOld(indexMonth) + "Actual"]} />
                                                                            </TableCell>
                                                                            :
                                                                            null
                                                                    }
                                                                    {
                                                                        [11].includes(indexMonth) ?
                                                                            <TableCell
                                                                                padding='none'

                                                                            >
                                                                                <TextFieldInputNumber value={itemTable.nTotalActual} />
                                                                            </TableCell>
                                                                            :
                                                                            null
                                                                    }
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </TableRow>
                                                <TableRow sx={{ backgroundColor: '#fdebd3' }}>
                                                    <TableCell className="sticky-cell pad-0 " padding='none' sx={{ backgroundColor: '#fdebd3' }} style={{ minWidth: '440px', width: '440px' }}>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                                        <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '80px', width: '80px' }}>ส่วนต่าง</TableCell>
                                                    </TableCell>
                                                    {
                                                        itemTable.lstActualMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                                            let keyCellInput = keyCellTable + "_" + keyRow.nOrder;
                                                            return (
                                                                <>
                                                                    <TableCell key={keyCellInput} padding='none' > </TableCell>
                                                                    {
                                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                                            <TableCell
                                                                                key={keyCellInput}
                                                                                padding='none'

                                                                            >
                                                                            </TableCell>
                                                                            :
                                                                            null
                                                                    }
                                                                    {
                                                                        [11].includes(indexMonth) ?
                                                                            <TableCell
                                                                                padding='none'

                                                                            >
                                                                                <TextFieldInputNumber value={itemTable.nTotalDiff} />
                                                                            </TableCell>
                                                                            :
                                                                            null
                                                                    }
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </TableRow>
                                            </Fragment>
                                        )
                                    })
                                }
                                <TableRow sx={{ backgroundColor: '#f2f2f2' }}>
                                    <TableCell className="sticky-cell pad-0 " component="th" padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='left' style={{ minWidth: '300px', width: '300px' }}>{ObjTotal.sProjectName}</TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '80px', width: '80px' }}>แผน</TableCell>
                                    </TableCell>
                                    {
                                        ObjTotal.lstExpenseMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                            let keyCellInput = "plan_" + keyRow.nOrder;
                                            return (
                                                <>
                                                    <TableCell
                                                        key={keyCellInput}
                                                        padding='none'
                                                        component={"th"}
                                                    >
                                                        <TextFieldInputNumber value={keyRow.value} />
                                                    </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell
                                                                key={keyCellInput}
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal["nQ" + calIndexOld(indexMonth)]} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal.nTotal} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </TableRow>
                                <TableRow>
                                    <TableCell className="sticky-cell pad-0 " component="th" padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '80px', width: '80px' }}>ผล</TableCell>
                                    </TableCell>
                                    {
                                        ObjTotal.lstActualMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                            let keyCellInput = "key";
                                            return (
                                                <>
                                                    <TableCell
                                                        key={keyCellInput}
                                                        padding='none'
                                                        component={"th"}
                                                    >
                                                        <TextFieldInputNumber value={keyRow.value} />
                                                    </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell
                                                                key={keyCellInput}
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal["nQ" + calIndexOld(indexMonth) + "Actual"]} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal.nTotalActual} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </TableRow>
                                <TableRow sx={{ backgroundColor: '#fdebd3' }}>
                                    <TableCell className="sticky-cell pad-0 " component="th" padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '80px', width: '80px' }}>ส่วนต่าง</TableCell>
                                    </TableCell>
                                    {
                                        ObjTotal.lstActualMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                            let keyCellInput = "totalActual_" + keyRow.nOrder;
                                            return (
                                                <>
                                                    <TableCell key={keyCellInput} padding='none' component={"th"} > </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal.nTotalDiff} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </TableRow>
                                <TableRow sx={{ backgroundColor: '#fdebd3' }}>
                                    <TableCell className="sticky-cell pad-0 " component="th" padding='none' sx={{ backgroundColor: '#f2f2f2' }} style={{ minWidth: '440px', width: '440px' }}>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '60px', width: '60px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='left' style={{ minWidth: '300px', width: '300px' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' component={"th"} align='center' style={{ minWidth: '80px', width: '80px' }}>ร้อยละ</TableCell>
                                    </TableCell>
                                    {
                                        ObjTotal.lstActualMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                            let keyCellInput = "totalActual_" + keyRow.nOrder;
                                            return (
                                                <>
                                                    <TableCell key={keyCellInput} padding='none' component={"th"} > </TableCell>
                                                    {
                                                        [2, 5, 8, 11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        [11].includes(indexMonth) ?
                                                            <TableCell
                                                                padding='none'
                                                                component={"th"}
                                                            >
                                                                <TextFieldInputNumber value={ObjTotal.nPercentage} />
                                                            </TableCell>
                                                            :
                                                            null
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </TableRow>
                            </>
                            :
                            <TableRow key={"r-no-data"}>
                                <TableCell align="center" colSpan={20}>
                                    ไม่พบข้อมูล
                                </TableCell>
                            </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default TableActualExpenseSectionProject


